import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import isNumeric from "ramda-extension/es/isNumeric";
import React from 'react';
import { useTopOffset } from '../../../context/topOffset';
import useIsMdAndUp from '../../../hooks/useIsMdAndUp';
import { NAVBAR } from '../../sizeConstants';
import { useDefaultComponentValue } from '../../utils';
import { SidebarContextProvider } from '../SidebarContext';
const COMPONENT_NAME = 'Sidebar';
const Sidebar = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { isOpenSidebar, onCloseSidebar, children, appName, sidebarWidth, ...other } = props;
    const topOffset = useTopOffset();
    const isMdAndUp = useIsMdAndUp();
    return /*#__PURE__*/ React.createElement(Box, {
        sx: (theme)=>({
                flexShrink: 0,
                transition: theme.transitions.create('width', {
                    duration: theme.transitions.duration.shorter
                }),
                width: {
                    md: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
                    xl: sidebarWidth
                },
                alignItems: 'center'
            })
    }, /*#__PURE__*/ React.createElement(SidebarContextProvider, {
        expandMode: true
    }, /*#__PURE__*/ React.createElement(Drawer, {
        anchor: "left",
        open: isOpenSidebar,
        onClose: onCloseSidebar,
        ...other,
        slotProps: {
            paper: {
                sx: {
                    width: sidebarWidth
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, null, appName && !isMdAndUp && /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            alignItems: 'flex-start',
            py: 2,
            px: 3,
            svg: {
                color: 'primary.main'
            }
        }
    }, typeof appName === 'string' ? /*#__PURE__*/ React.createElement(Typography, null, appName) : appName), children))), isMdAndUp && isNumeric(topOffset) && /*#__PURE__*/ React.createElement(SidebarContextProvider, {
        expandMode: false
    }, /*#__PURE__*/ React.createElement(Drawer, {
        open: true,
        variant: "persistent",
        slotProps: {
            paper: {
                sx: {
                    top: topOffset,
                    height: `calc(100% - ${topOffset}px)`,
                    width: {
                        md: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
                        xl: sidebarWidth
                    },
                    transition: (theme)=>theme.transitions.create('width', {
                            duration: theme.transitions.duration.shorter
                        })
                }
            }
        },
        ...other
    }, /*#__PURE__*/ React.createElement(Box, null, children))));
};
Sidebar.propTypes = {
    appName: PropTypes.node,
    children: PropTypes.node.isRequired,
    isDesktop: PropTypes.bool,
    isOpenSidebar: PropTypes.bool,
    onCloseSidebar: PropTypes.func,
    sidebarWidth: PropTypes.number
};
export default Sidebar;
